import { Api } from "@/plugins/api"

export const creationCompte = (creationDeCompteModel) => {
  return Api.post('sas/creation-de-compte', creationDeCompteModel)
}

export const initFormulaire = (endpoint, contactId, sasBuilderBuildParam, estFormulairePublic) => {
  if (estFormulairePublic) {
    return Api.post(endpoint + "/init", sasBuilderBuildParam)
  } else {
    return Api.post(endpoint + "/init/" + contactId, sasBuilderBuildParam)
  }
}

export const getSas = (endpoint, sasId) => {
  return Api.get(endpoint + sasId)
}

export const submitSas = (sasId) => {
  return Api.post('sas/submit/' + sasId)
}
